module.exports = "/_next/static/images/321f7a46ab5e3b1f3614788cae1ce882-worldcup-md-2x.jpg";